import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';
import Reveal from '@/components/base/Reveal';
import { topics } from '@/mocks/topics';
import { formatHeat } from '@/utils/format';

export default function HotRanking() {
  const ranked = [...topics].sort((a, b) => b.heat - a.heat).slice(0, 8);
  const maxHeat = ranked[0]?.heat ?? 1;

  return (
    <section className="w-full bg-background-50 py-14 md:py-20" id="hot">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Reveal>
          <SectionTitle
            eyebrow="Hot List"
            title="热搜榜速览"
            desc="按当前讨论热度实时排序，热度值综合了话题阅读、评论与转发量。"
            action={
              <Link
                to="/topics"
                className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                全部话题
                <i className="ri-arrow-right-line" />
              </Link>
            }
          />
        </Reveal>

        <ol className="mt-8 space-y-2">
          {ranked.map((topic, index) => (
            <Reveal key={topic.id} delay={index * 40}>
              <li>
                <Link
                  to={`/topics/${topic.id}`}
                  className="group flex cursor-pointer items-center gap-4 rounded-lg border border-transparent bg-background-100/70 px-4 py-3.5 transition-colors hover:border-primary-200 hover:bg-primary-50"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                      index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700 md:text-base">
                      {topic.title}
                    </h3>
                    <div className="mt-1.5 flex items-center gap-3">
                      <span className="hidden text-xs text-foreground-500 sm:block">{topic.category}</span>
                      <div className="h-1.5 w-full max-w-[220px] overflow-hidden rounded-full bg-background-300">
                        <div
                          className="h-full rounded-full bg-accent-500"
                          style={{ width: `${Math.round((topic.heat / maxHeat) * 100)}%` }}
                        />
                      </div>
                    </div>
                  </div>
                  <span className="flex shrink-0 items-center gap-1 text-xs font-medium text-primary-600">
                    <i className="ri-fire-line" />
                    {formatHeat(topic.heat)}
                  </span>
                </Link>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}